module.exports = "/lucky-balls/img/combos-sr/210.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos-sr/210.png
// module id = 987
// module chunks = 0